import React from 'react'
import { connect } from 'react-redux'
import Logo  from '../../assets/icon/logoxs.png'
import './loading.css'
import { 
    LoadingOutlined
    } from '@ant-design/icons'
const mapStateToProps=(state)=>{
    return{
        showLoading:state.showLoading
    }
}

const Loading = (props) => {
    
    return (
        <>
            {
            props.showLoading?(
                <div className='loadMain' >
                    <div className='loadMain1'>
                        {/* <img alt='loading'  className="loadingIcon" src={Logo}></img> */}
                        <LoadingOutlined style={{"fontSize":"30px"}}/>
                        Loading
                    </div>
                </div>
            ):null
            }
        </>
        
        
    );
}

export default connect(mapStateToProps)(Loading);
